export function greenSheetGalles() {
return [   //2024 Release 2025-05-06 18:52:34
 
{
   page: 0,
   name: "Purchase Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 99.36,
   left: 133.44,
   width: 167.40,
   height: 12.884
}
,
{
   page: 0,
   name: "date Closing Date", 
   fontSize: 9,
   type: "date",
   top: 99.36,
   left: 432.24,
   width: 125.52,
   height: 12.884
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 122.16,
   left: 83.4,
   width: 215.16,
   height: 12.884
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 122.16,
   left: 344.4,
   width: 215.16,
   height: 12.884
}
,
{
   page: 0,
   name: "Lisng Agent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 144.96,
   left: 117.72,
   width: 41.88,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 144.96,
   left: 256.2,
   width: 89.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Selling Agent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 167.76,
   left: 118.44,
   width: 41.88,
   height: 12.884
}
,
{
   page: 0,
   name: "signature ListingAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 375.797,
   left: 101.804,
   width: 210.042,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 167.76,
   left: 256.2,
   width: 89.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Listing Agent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 224.4,
   left: 119.4,
   width: 167.28,
   height: 12.884
}
,
{
   page: 0,
   name: "Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 224.4,
   left: 363.24,
   width: 197.28,
   height: 12.884
}
,
{
   page: 0,
   name: "Commission X Split", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 249.36,
   left: 158.64,
   width: 107.52,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 249.36,
   left: 454.2,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Galles Community Fund", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 268.32,
   left: 171.48,
   width: 95.52,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 268.32,
   left: 454.2,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "CoList Agent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 287.52,
   left: 119.52,
   width: 149.40,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 287.52,
   left: 454.2,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Referral", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 306.72,
   left: 93.48,
   width: 173.28,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 306.48,
   left: 454.2,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Client Home CityState", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 342.48,
   left: 166.32,
   width: 143.52,
   height: 12.884
}
,
{
   page: 0,
   name: "Source If Galles Client", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 342.48,
   left: 434.04,
   width: 125.52,
   height: 12.884
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 376.08,
   left: 393.48,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Selling Agent_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 426.72,
   left: 120.24,
   width: 167.28,
   height: 12.884
}
,
{
   page: 0,
   name: "Company_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 426.72,
   left: 363.24,
   width: 197.28,
   height: 12.884
}
,
{
   page: 0,
   name: "Commission X Split_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 451.68,
   left: 158.64,
   width: 107.52,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 451.68,
   left: 454.2,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Galles Community Fund_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 470.64,
   left: 171.48,
   width: 95.52,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 470.64,
   left: 454.2,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "CoSell Agent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 489.84,
   left: 120.12,
   width: 149.40,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 489.84,
   left: 454.2,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Referral_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 509.04,
   left: 93.48,
   width: 173.28,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 508.8,
   left: 454.2,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "Client Home CityState_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 544.8,
   left: 166.32,
   width: 143.52,
   height: 12.884
}
,
{
   page: 0,
   name: "Source If Galles Client_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 544.8,
   left: 434.04,
   width: 119.52,
   height: 12.884
}
,
{
   page: 0,
   name: "signature SellingAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 577.582,
   left: 100.495,
   width: 212.006,
   height: 12.883
}
,
{
   page: 0,
   name: "Date_2", 
   fontSize: 9,
   type: "date",
   top: 577.4,
   left: 393.48,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "X", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 629.04,
   left: 290.4,
   width: 53.76,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 629.04,
   left: 466.8,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "X_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 646.0,
   left: 289.2,
   width: 53.76,
   height: 12.884
}
,
{
   page: 0,
   name: "undefined_13", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 646.0,
   left: 466.8,
   width: 95.64,
   height: 12.884
}
,
{
   page: 0,
   name: "X_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 679.44,
   left: 291.24,
   width: 53.76,
   height: 12.8837
}
,
{
   page: 0,
   name: "undefined_14", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 679.44,
   left: 466.8,
   width: 95.64,
   height: 12.8837
}
,
{
   page: 0,
   name: "X_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 696.4,
   left: 291.96,
   width: 53.76,
   height: 12.8837
}
,
{
   page: 0,
   name: "undefined_15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 696.4,
   left: 466.8,
   width: 95.64,
   height: 12.8837
}
,
{
   page: 0,
   name: "undefined_16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 730.08,
   left: 466.8,
   width: 95.64,
   height: 12.8837
}
,
{
   page: 0,
   name: "Text3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 144.655,
   left: 357.383,
   width: 205.637,
   height: 54.073
}
,
{
   page: 0,
   name: "Text4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 717.385,
   left: 36.6547,
   width: 330.6553,
   height: 60.6184
}
] }
